// Extract data based on filterName and its value

const extractArrayData = <T>(
  itemArray: Array<T> | undefined,
  filterName: string,
  id: string,
): T | undefined => itemArray?.find((item) => item && item[filterName] === id);

export default extractArrayData;
